import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HomeComponent } from 'src/app/home/home.component';
import { NgxSpinnerService } from "ngx-spinner";
import { style } from '@angular/animations';
import { bindCallback, Subscription } from 'rxjs';

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.css']
})
export class UserHeaderComponent implements OnInit, OnDestroy {

  public fileNo: any;
  public email: any;
  public referrals_name: any;
  public referrals_email: any;
  public referrals_Phone: number;
  public referrals_comments: any;
  // @@@@@@@@@@@@@@@@@

  dataa: any;
  baseUrl: string;
  public password: any;
  public userEmail: any;
  // public email = this.userEmail;
  public userName: any;
  public user = this.userName;

  subscription : Subscription;
  public ID: any;

  // public userId=this.ID;
  public cnf_password: any;
  public new_password: any;
  url: string;
  a: any;
  black: string;
  color: string;
  docs: string;
  fileNumber:any;

  constructor(public router: Router,
    public toastr: ToastrService,
    public usr: UserService,
    private SpinnerService: NgxSpinnerService) {
  }

  ngOnInit(): void {
     this.subscription = this.usr.fileNum.subscribe((fileNumber)=>{
        this.fileNo = fileNumber;
    });

    let a = localStorage.getItem("data");
    let b = localStorage.getItem("newFileNo");
      this.fileNumber = JSON.parse(a);
      if(this.fileNumber == null || this.fileNumber == undefined)
      {
        this.router.navigate(['home']);
      }
      this.fileNo = b;
    this.url = this.router.url;
  }
  logout() {
    this.SpinnerService.show();
    this.usr.logout().subscribe(
      (res: any) => {
        if (res.code === 200) {
          this.SpinnerService.hide();
          this.usr.loggedIn = false;
          this.toastr.success(res.message);
          localStorage.clear();
          this.router.navigate(['home']);

        } else {
          this.SpinnerService.hide();
          this.toastr.error(res.message);
          this.router.navigate(['home']);
        }
      },
      (err: any) => {
        this.SpinnerService.hide();
        this.router.navigate(['home']);
      }
    )
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }
}
